import 'css-chunksrc/client/pages/accountPage/styles.scss';export default {
  "account": "_account_13mxh_1",
  "header": "_header_13mxh_9",
  "profileNavigation": "_profileNavigation_13mxh_19",
  "title": "_title_13mxh_27",
  "main": "_main_13mxh_33",
  "sidebar": "_sidebar_13mxh_43",
  "content": "_content_13mxh_47",
  "section": "_section_13mxh_55",
  "subTitle": "_subTitle_13mxh_59",
  "sectionContent": "_sectionContent_13mxh_65"
};